module.exports = __webpack_public_path__ + "static/pic10-2f94bfae856fab1193ae1cf860962288.jpeg";